module.exports = __webpack_public_path__ + "static/media/logo_solo.887248dd.svg";